import http from "../http";

export const uploadImage = (formData) =>
  http.post("/store-management/upload/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
